module.exports = __webpack_public_path__ + "media/floorPlans/floorPlansBase-363e2334.png";